export interface ProjectItem {
  id: string
  name: string
  slug: string
  logoUrl?: string
  imageUrl?: string
  tag?: string
  org?: string
}

/**
 * Hand-curated projects for the /start "Unterstützte Hilfsprojekte" spotlight — STATIC by design.
 *
 * Why static: these six broad-appeal projects are scattered across 260+ projects, so the paginated
 * `/projects/withAssociations` list the spotlight used to read from rarely surfaced them — only one
 * of the six landed in the first `size:50` page, collapsing the rotating pool to a single card and
 * freezing the section. Baking the selection here (same pattern as `curated-products.ts`) makes the
 * spotlight deterministic and always full, independent of pagination/sort.
 *
 * Snapshotted 2026-07-04 from `/projects/bySlug/{slug}/detail`. `imageUrl` is a chosen cover photo
 * from the project's description (rendered via a plain <img> in `CoverImage`, so external hosts are
 * fine); when omitted, the card falls back to a branded gradient + logo. To refresh: re-fetch the
 * detail endpoint, pick a stable photo URL, and update the entry.
 */
export const CURATED_PROJECTS: ProjectItem[] = [
  {
    id: "74b658a2-d0a0-3179-adc4-cb6d921db482",
    name: "Wilderness International",
    slug: "wilderness-international",
    logoUrl: "https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/charity/logo/ccc39609-be9b-3bb1-bdec-284828438bbb.png",
    imageUrl: "https://d2ijqnyf2ixq2j.cloudfront.net/media/Canada/bog-canada.jpg",
    tag: "Völkerverständigung",
    org: "Wilderness International",
  },
  {
    id: "fa55d396-4b21-3962-bbc6-793570283d26",
    name: "WI Agroforst Secret Forest",
    slug: "wi-agroforst-secret-forest",
    logoUrl: "https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/project/logo/fa55d396-4b21-3962-bbc6-793570283d26.png",
    imageUrl: "https://d2ijqnyf2ixq2j.cloudfront.net/media/Peru/Marie-Stefany-Agroforst-Peru_MattisWeber.jpg",
    tag: "Forschung",
    org: "Wilderness International",
  },
  {
    id: "7feb28d7-da2e-34fa-a747-4b07a94459f3",
    name: "WI Perú Educa",
    slug: "wi-peru-educa",
    logoUrl: "https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/project/logo/7feb28d7-da2e-34fa-a747-4b07a94459f3.png",
    // Its 2nd description photo reads better than the first.
    imageUrl: "https://d2ijqnyf2ixq2j.cloudfront.net/media/Peru/Pilot%20school%20visit%20to%20SFO-2.jpeg",
    tag: "Völkerverständigung",
    org: "Wilderness International",
  },
  {
    id: "97c6f021-67c5-36bd-9891-99b8b816dd87",
    name: "Cura Placida",
    slug: "cura-placida",
    logoUrl: "https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/project/logo/97c6f021-67c5-36bd-9891-99b8b816dd87.png",
    imageUrl: "https://curaplacida.org/wp-content/uploads/2024/04/TEAM_2024_image_1920x800px_alt_k.jpg",
    tag: "Gesundheitshilfe",
    org: "Cura Placida",
  },
  {
    id: "3198d93d-9adc-3187-b86a-ab771c12f708",
    name: "Hüttenbacher Stachelritter",
    slug: "huettenbacher-stachelritter",
    logoUrl: "https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/charity/logo/156f0de9-b407-3263-8ef1-9e9423449139.jpg",
    // betterplace-hosted photo (stable). The project's other images are facebook CDN URLs
    // with expiring `oe=` tokens — do NOT use those, they break after a few days.
    imageUrl: "https://betterplace-assets.betterplace.org/uploads/project/profile_picture/000/154/816/fill_730x380_f624c255-3ccd-46a8-a8a0-30ce5575988a.JPEG",
    tag: "Tierschutz",
    org: "Hüttenbacher Stachelritter",
  },
  {
    id: "67ab205e-b4aa-37dd-89ca-42c83c886944",
    name: "donista Beach",
    slug: "donista-beachvolleys",
    logoUrl: "https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/project/logo/67ab205e-b4aa-37dd-89ca-42c83c886944.png",
    // No stable cover photo: the only description image is a flaky DuckDuckGo proxy URL (a broken
    // <img> would show a broken-image icon). Omitting imageUrl falls back cleanly to the branded
    // gradient + logo placeholder in CoverImage. Add a hosted photo here if one becomes available.
    tag: "Sport",
    org: "donista",
  },
]
